import { SidebarItemConfig } from '../../types/sidebarItemConfig';

const SIDEBAR_ITEM_TEST_ID_PREFIX = 'sidebar-item-';

export interface SidebarItemsSlotProps {
  items: SidebarItemConfig[];
  shouldShowExpanded: boolean;
  isMobile: boolean;
  onToggleOpen: () => void;
}

export function SidebarItemsSlot({
  items,
  shouldShowExpanded,
  isMobile,
  onToggleOpen,
}: Readonly<SidebarItemsSlotProps>) {
  return (
    <>
      {items.map(({ id, component: Component, props, requiresOpen }) => {
        if (requiresOpen && !shouldShowExpanded) {
          return null;
        }

        return (
          <Component
            key={id}
            {...props}
            dataTestId={`${SIDEBAR_ITEM_TEST_ID_PREFIX}${id}`}
            isOpen={shouldShowExpanded}
            onNavigate={isMobile ? onToggleOpen : undefined}
          />
        );
      })}
    </>
  );
}
